import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, Subscription } from 'rxjs';
import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { OrderShuttleBusService } from '../../../../../services/ordershuttlebus.service';
import { OrderShuttleService } from '../../../../../services/ordershuttle.service';
import { DatePipe } from '@angular/common';
import { PlannedShuttleBuss } from '../../../../../models/ShuttleBookingModel';
import { OrderShuttleVM } from '../../../../../models/orderModel';
import { BackOffice24OrderShuttlebusCreateComponent } from '../back-office24-ordershuttlebus-create/back-office24-ordershuttlebus-create.component';
import { MyBusComponent } from '../../my-bus/my-bus.component';
// import { BackOffice24OrderShuttlebusPlanArrivalComponent } from '../back-office24-ordershuttlebus-plan/back-office24-ordershuttlebus-plan-arrival/back-office24-ordershuttlebus-plan-arrival.component';
// import { BackOffice24OrderShuttlebusPlanDepartureComponent } from '../back-office24-ordershuttlebus-plan/back-office24-ordershuttlebus-plan-dep/back-office24-ordershuttlebus-plan-dep.component';
import { EventQueueService, AppEventType } from '../../../../../services/eventqueue.service';
import { MyConfigService } from '../../../../../services/my-config.service';
import { MyConfigOrganization } from '../../../../../models/myConfig';
import { AuthService } from '../../../../../services/auth.service';
import { BackOffice24StatesService } from '../../state/back-office24-states.service';

export class TabItem {
  header: string;
  orderShuttleBusId: string;
  orderShuttleBus: PlannedShuttleBuss;
}

@Component({
  selector: 'app-back-office24-ordershuttlebus-checkin',
  templateUrl: './back-office24-ordershuttlebus-checkin.component.html',
  styleUrl: './back-office24-ordershuttlebus-checkin.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderShuttlebusCheckinComponent implements OnInit, OnDestroy {
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();
  dateFrom: string;
  dateTo: string;
  timeFrom: string;
  timeTo: string;
  showActive: boolean = true;
  showPlanned: boolean = true;
  showDeparted: boolean = false;
  showArrived: boolean = false;
  showCancelled: boolean = false;
  showNoPassengers: boolean = false;
  orderShuttleForm: UntypedFormGroup;
  orderShuttleBussesDep: PlannedShuttleBuss[] = [];
  orderShuttleBussesArr: PlannedShuttleBuss[] = [];
  //TODO: Not used in html
  orderShuttlesPickup: OrderShuttleVM[] = [];
  //TODO: Not used in html
  orderShuttlesDeparture: OrderShuttleVM[] = [];
  //TODO: Not used in html
  orderShuttlesArrival: OrderShuttleVM[] = [];

  orderShuttles: OrderShuttleVM[] = [];

  dataSource: MatTableDataSource<PlannedShuttleBuss>;
  isLoading = false;
  tabList: Map<string, TabItem> = new Map();
  selectedTabIndex: number = 0;
  totalDepartureOrders: number = 0;
  totalDeparturePassengers: number = 0;
  totalDeparturePickupCars: number = 0;
  totalDeparturePickupPeople: number = 0;
  totalArrivalPickups: number = 0;
  totalArrivalPersons: number = 0;
  totalArrivalOrders: number = 0;
  totalArrivalPassengers: number = 0;
  intervalId: any;
  componentDestroyed$: Subject<boolean> = new Subject();
  organizationId: string;


  constructor(
    public orderShuttleBusService: OrderShuttleBusService,
    public orderShuttleService: OrderShuttleService,
    public dialog: MatDialog,
    public router: Router,
    private fb: UntypedFormBuilder,
    public datepipe: DatePipe,
    public eventQueue: EventQueueService,
    private route: ActivatedRoute,
    private myConfigService: MyConfigService,
    private authService: AuthService,
    public backOffice24StatesService: BackOffice24StatesService,
  ) { }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.subscribe(
      org => this.organization = org
    );

    this.initShuttles();
    this.checkMandatoryBusSelection();
    this.intervalId = setInterval(() => this.refresh(), 60000);
    this.eventQueue.on(AppEventType.BusCheckinClearTabs).subscribe(event => this.clearTabs());
  }

  checkMandatoryBusSelection(): void {
    if (!this.authService.loggedIn()) {
      return;
    }
    const userId = this.authService.getUserId() || 'user';
    const hasSelectedBusThisSession = sessionStorage.getItem(`shuttle_checkin_bus_selected_${userId}`);
    if (!hasSelectedBusThisSession) {
      this.openMyBusDialog(true);
    }
  }

  openMyBusDialog(mandatory: boolean = false): void {
    const dialogRef = this.dialog.open(MyBusComponent, {
      width: '500px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: mandatory,
      autoFocus: false,
      data: { isDialog: true, mandatory }
    });

    dialogRef.afterClosed().subscribe((selected) => {
      if (selected) {
        const userId = this.authService.getUserId() || 'user';
        sessionStorage.setItem(`shuttle_checkin_bus_selected_${userId}`, 'true');
      }
      this.getShuttleBusses();
    });
  }

  initShuttles() {
    this.dateFrom = moment().add(-1, 'd').format();
    this.timeFrom = "00:00";
    this.dateTo = moment().add(1, 'd').format();
    this.timeTo = "00:00";
    this.initOrderShuttleForm();
    this.refresh();
  }

  initOrderShuttleForm() {
    this.orderShuttleForm = this.fb.group({
      dateFrom: [this.dateFrom],
      timeFrom: [this.timeFrom],
      dateTo: [this.dateTo],
      timeTo: [this.timeTo]
    });
  }

  refresh() {
    if (!this.authService.loggedIn()) {
      return;
    }
    this.getShuttleBusses();
    this.getOrderShuttlesPaid();
    // this.getOrderShuttlesPickup();
  }

  //TODO: This function is always being called even when only changing the filter
  // We could cache the result from the backend and just return different results based on the filter
  // There is a timer that refreshes the list every 60s so it will be up to date
  // What if the refresh just gets the last 10 min and merge it into the cache?

  // This function only needs routeName, status, startDate, driverName, busName, seats, passengers
  getShuttleBusses() {
    //this.isLoading = true;
    this.setDateFormats();

    this.orderShuttleBusService
      .getOrderShuttleBusBetweenShuttleDate(this.dateFrom, this.dateTo)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderShuttleBusses => {

        this.orderShuttleBussesArr = [];
        this.orderShuttleBussesDep = [];

        orderShuttleBusses.forEach(orderShuttleBus => {

          if (orderShuttleBus.status === 'Planned' && this.showPlanned) {
            if (orderShuttleBus.passengers != 0 || (orderShuttleBus.passengers == 0 && this.showNoPassengers)) {
              if (orderShuttleBus.routeType == 'DEPARTURE') {
                this.orderShuttleBussesDep.push(orderShuttleBus);
              } else {
                this.orderShuttleBussesArr.push(orderShuttleBus);
              }
            }
          }

          if (orderShuttleBus.status === 'Active' && this.showActive) {
            if (orderShuttleBus.routeType == 'DEPARTURE') {
              this.orderShuttleBussesDep.push(orderShuttleBus);
            } else {
              this.orderShuttleBussesArr.push(orderShuttleBus);
            }
          }

          if (orderShuttleBus.status === 'Departed' && this.showDeparted) {
            if (orderShuttleBus.passengers != 0 || (orderShuttleBus.passengers == 0 && this.showNoPassengers)) {
              if (orderShuttleBus.routeType == 'DEPARTURE') {
                this.orderShuttleBussesDep.push(orderShuttleBus);
              } else {
                this.orderShuttleBussesArr.push(orderShuttleBus);
              }
            }
          }

          if (orderShuttleBus.status === 'Arrived' && this.showDeparted) {
            if (orderShuttleBus.passengers != 0 || (orderShuttleBus.passengers == 0 && this.showNoPassengers)) {
              if (orderShuttleBus.routeType == 'DEPARTURE') {
                this.orderShuttleBussesDep.push(orderShuttleBus);
              } else {
                this.orderShuttleBussesArr.push(orderShuttleBus);
              }
            }
          }

          if (orderShuttleBus.status == 'Cancelled' && this.showCancelled) {
            if (orderShuttleBus.passengers != 0 || (orderShuttleBus.passengers == 0 && this.showNoPassengers)) {
              if (orderShuttleBus.routeType == 'DEPARTURE') {
                this.orderShuttleBussesDep.push(orderShuttleBus);
              } else {
                this.orderShuttleBussesArr.push(orderShuttleBus);
              }
            }
          }
        });

        //this.isLoading = false;
      });
  }

  getOrderShuttlesPaid() {

    // Get +-12h for OrderShuttleBusBookingsComponent
    const fromDate = moment().format('YYYY-MM-DD') + 'T00:00';
    const toDate = moment().format('YYYY-MM-DD') + 'T23:59';

    const extendedFrom = moment(fromDate).add(-12, 'hours');
    const extendedTo = moment(toDate).add(12, 'hours');

    this.orderShuttleService
      .getOrderShuttlesPaidOrganizationBetweenShuttleDate(this.organization.organizationId, extendedFrom.format('YYYY-MM-DDTHH:mm'), extendedTo.format('YYYY-MM-DDTHH:mm'))
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderShuttles => {
        this.orderShuttles = orderShuttles;
        // Remove +-12h for this component
        let orderShuttlesFiltered = orderShuttles.filter(s => moment(s.shuttleDate) >= moment(fromDate) && moment(s.shuttleDate) <= moment(toDate))
        this.setOrderShuttlesPickup(orderShuttlesFiltered);

        this.orderShuttlesDeparture = [];
        this.orderShuttlesArrival = [];

        orderShuttlesFiltered.forEach(orderShuttle => {
          if (orderShuttle.status == 'Paid') {
            if (orderShuttle.productType == 'ShuttleDeparture') {
              this.orderShuttlesDeparture.push(orderShuttle);
            }
            if (orderShuttle.productType == 'ShuttleArrival') {
              this.orderShuttlesArrival.push(orderShuttle);
            }
          }
        });
        this.totalDepartureOrders = this.orderShuttlesDeparture.length;
        this.totalArrivalOrders = this.orderShuttlesArrival.length;
        this.totalDeparturePassengers = this.orderShuttlesDeparture.reduce(function (a, b) { return a + b['passengers']; }, 0);
        this.totalArrivalPassengers = this.orderShuttlesArrival.reduce(function (a, b) { return a + b['passengers']; }, 0);

      });
  }

  setOrderShuttlesPickup(orderShuttles: OrderShuttleVM[]) {
    let pickups = orderShuttles.filter(s => s.status === 'ReadyForPickup');

    this.orderShuttlesPickup = [];
    this.orderShuttlesPickup = pickups;
    this.totalDeparturePickupCars = this.orderShuttlesPickup.filter(orderShuttle => orderShuttle.productType == "ShuttleDeparture").length;
    this.totalDeparturePickupPeople = this.orderShuttlesPickup.filter(orderShuttle => orderShuttle.productType == "ShuttleDeparture").reduce((acc, current) => acc + current.passengers, 0);

    this.totalArrivalPickups = this.orderShuttlesPickup.filter(orderShuttle => orderShuttle.productType == "ShuttleArrival").length;
    this.totalArrivalPersons = this.orderShuttlesPickup.filter(orderShuttle => orderShuttle.productType == "ShuttleArrival").reduce((acc, current) => acc + current.passengers, 0);
  }

  setDateFormats() {
    this.dateFrom = this.datepipe.transform(this.orderShuttleForm.controls['dateFrom'].value, 'yyyy-MM-dd') + 'T' + this.orderShuttleForm.controls['timeFrom'].value;
    this.dateTo = this.datepipe.transform(this.orderShuttleForm.controls['dateTo'].value, 'yyyy-MM-dd') + 'T' + this.orderShuttleForm.controls['timeTo'].value;
  }

  showBusDetails(orderShuttleBus: PlannedShuttleBuss): void {
    this.tabList.set(orderShuttleBus.orderShuttleBusId, <TabItem>{
      header: orderShuttleBus.routeName + ' ' + moment(orderShuttleBus.startDate).format('YYYY-MM-DD HH:mm'),
      orderShuttleBusId: orderShuttleBus.orderShuttleBusId,
      orderShuttleBus: orderShuttleBus
    });

    // Find the index of the tab with matching orderShuttleBusId
    const tabArray = Array.from(this.tabList.values());
    const tabIndex = tabArray.findIndex(tab => tab.orderShuttleBusId === orderShuttleBus.orderShuttleBusId);

    if (tabIndex !== -1) {
      this.selectedTabIndexChange(tabIndex + 2);
    }
  }

  get tabListValues(): TabItem[] {
    return Array.from(this.tabList.values());
  }

  clearTabs() {
    this.getShuttleBusses();
    this.tabList.clear();
    this.selectedTabIndexChange(0);
  }

  selectedTabIndexChange(val: number) {
    this.selectedTabIndex = val;
  }

  createOrderShuttleBus(routeType: string): void {
    const dialogRef = this.dialog.open(BackOffice24OrderShuttlebusCreateComponent, {
      height: '500px',
      width: '720px',
      hasBackdrop: true,
      data: routeType
    });

    dialogRef.afterClosed().subscribe((orderShuttleBus: PlannedShuttleBuss) => {

      if (orderShuttleBus) {
        this.showBusDetails(orderShuttleBus);

        if (routeType == 'ARRIVAL') {
          this.orderShuttleBussesArr.unshift(orderShuttleBus);
        }

        if (routeType == 'DEPARTURE') {
          this.orderShuttleBussesDep.unshift(orderShuttleBus);
        }
      }
    });
  }

  valueChangePlanned($event) {
    this.showPlanned = $event.checked;
    this.getShuttleBusses();
  }

  valueChangeActive($event) {
    this.showActive = $event.checked;
    this.getShuttleBusses();
  }

  valueChangeDeparture($event) {
    this.showDeparted = $event.checked;
    this.getShuttleBusses();
  }

  valueChangeArrival($event) {
    this.showArrived = $event.checked;
    this.getShuttleBusses();
  }

  valueChangeCancelled($event) {
    this.showCancelled = $event.checked;
    this.getShuttleBusses();
  }

  valueChangeNoPassengers($event) {
    this.showNoPassengers = $event.checked;
    this.getShuttleBusses();
  }

  // openArrivalPlanning() {
  //   this.dialog.open(BackOffice24OrderShuttlebusPlanArrivalComponent, {
  //     height: '900px',
  //     width: '720px',
  //     hasBackdrop: true,
  //     data: null
  //   });
  // }

  // openDeparturePlanning() {
  //   this.dialog.open(BackOffice24OrderShuttlebusPlanDepartureComponent, {
  //     height: '900px',
  //     width: '720px',
  //     hasBackdrop: true,
  //     data: null
  //   });
  // }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  flatten(obj: any) {
    return Object.keys(obj).reduce((acc, current) => {
      const _key = `${current}`;
      const currentValue = obj[current];
      if (Array.isArray(currentValue) || Object(currentValue) === currentValue) {
        Object.assign(acc, this.flatten(currentValue));
      } else {
        acc[_key] = currentValue;
      }
      return acc;
    }, {});
  }

  ngOnDestroy() {
    this.orgSubscription.unsubscribe();
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
    clearInterval(this.intervalId);
  }
}
